import * as React from 'react';

import type * as api from '@gitbook/api-client';
import { normalizeStyle, type StyleProp, type ViewStyle } from '@gitbook/react-uikit';

import type { ContentKitElementProps } from './types';

export const ContentKitImageRenderContext = React.createContext<'inline' | 'block'>('block');

export function ContentKitImage(
    props: ContentKitElementProps<api.ContentKitImage> & {
        style?: StyleProp<ViewStyle>;
    }
): React.ReactElement {
    const { element, style } = props;
    const display = React.useContext(ContentKitImageRenderContext);

    return display === 'block' ? (
        <div
            className="relative w-full"
            style={normalizeStyle([{ aspectRatio: element.aspectRatio }, style])}
        >
            <img
                className="absolute inset-0 size-full object-cover"
                src={element.source.url}
                alt=""
            />
        </div>
    ) : (
        <img className="size-6" src={element.source.url} alt="" />
    );
}
